<template>
    <div class="text-dark">
        <!-- <textarea v-model="internalValue.discursive.value" style="max-width: 400px; height: 350px;"></textarea> -->
        
        <vs-textarea v-model="internalValue.discursive.value" />
    </div>
</template>

<script>
import Vue from 'vue'

export default {
    components : {
    },

    props: {
        // THE V-MODEL TO RECEIVED THE INFORMATION BACK
        value : {
            type: Object,
            required: false,
            default : () => {
                return {
                    'discursive' : {
                        value: ''
                    }
                }
            }
        },
        maxTime: {
            type: Number,
            default: null
        }
    },

    data() {
        return {
            internalValue : this.value,
            inputId : null,
            options : {
                timer: this.maxTime // IN SECONDS
            },
            timer: {
                started : null,
                finished : null,
                diff: null,
                interval: null,
                remaining : null,
                percent : null
            }
        }
    },

    created() {
    },

    mounted() {
    },

    computed : {
    },

    methods: {

        recordSession() {
            this.startTimer();
            this.$emit('started');
        },

        startTimer() {
            this.timer.total = this.options.timer;
            this.timer.started = new Date().getTime();

            this.timer.interval = setInterval(() => {
                let diff = new Date().getTime() - this.timer.started;

                if (this.timer.total) {

                    this.timer.remaining = Math.round(this.options.timer - (diff / 1000));

                    if (this.timer.remaining <= 0) {
                        this.$emit('expired', this.timer);
                        //this.finishSession();
                    }
                }

                this.timer.diff = Math.round(diff / 1000);

                this.$emit('timer', this.timer);

            }, 1000);
        },
        stopTimer() {
            this.timer.finished = new Date().getTime();
            clearInterval(this.timer.interval);
        },
        pushEvent(event) {
            this.logs.push(event);
        },
        finishSession() {
            return new Promise((resolve, reject) => {
                this.stopTimer();
                this.$emit('stopped');
                resolve(this.internalValue, false)
            });
            //this.internalValue = this.$refs.input.value;
        }
    }
}

</script>

<style scope>

.vr-container {
    /* border: 1px dashed #aaa; */
    background: hsla(220, 40%, 10%, 1);
}
.vr-container h5 {
	color: #2fc7f7;
	font-size: 1.6em;
	text-align: center;
}

.vr-container .vr-pre-actions, .vr-container .vr-pos-actions {
	padding-top: 7px;
	width: 100%;
	height: 100%;
}

.vr-pre-actions-buttons, .vr-pos-actions-buttons {
	display: flex;
	text-align: center;
}

.vr-pre-actions-buttons p, .vr-pos-actions-buttons{
	color: #dedede;
	font-size: 1.2em;
}

.vr-pre-actions-buttons div {
	width: 50%;
	cursor: pointer;
}

.vr-pos-actions-buttons div {
	width: 33%;
	cursor: pointer;
}

.vr-container .hidden {
	display: none;
}

.vr-download-video {
	text-decoration: none;
	color: #dedede;
}

.vr-rec-div {
	position: absolute;
	right: 5;
	display: flex;
	padding-top: 10px;
	padding-left: 10px;
}

.vr-rec-div span {
	font-size: 1.1em;
	color: #000;
}

.vr-rec-light {
	margin-top: 5px;
	margin-left: 5px;
	height: 12px;
	width: 12px;
	background: #c7084b;
	border-radius: 100px;
	animation: blinker 1s linear infinite;
}

.vr-time-blinking {
	animation: blinker 1s linear infinite;
	background-color: #cc0000!important;
	font-weight: bold;
}

@keyframes blinker {
    50% {
	    opacity: 0;
    }
}

.vr-record-time {
	font-family: 'Orbitron', sans-serif;
	font-size: 1.7em;
	width: fit-content;
	background: #222;
	padding: 4px;
	border-radius: 5px;
	color: #dedede;
	position: absolute;
	bottom: 0;
}

.vr-pre-time {
	font-size: 10em;
	color: #ddd;
	text-align: center;
	padding-top: 50px;
}

.vr-stop-div {
	position: absolute;
	bottom: 10px;
	left: 50%;
	-webkit-transform: translateX(-50%);
	transform: translateX(-50%);
	cursor: pointer;
	z-index: 1;
    opacity: 0;
    transition: opacity 1s ease-in-out;
}

.vr-container:hover .vr-stop-div {
    opacity: 1;
}

.vr-image {
	width: 70px!important;
	height: 70px!important;
	display: inline-block;
}

.vr-image-stop {
	width: 50px!important;
	height: 50px!important;
	display: inline-block;
}

.vr-pre-actions-buttons, .vr-pos-actions {
	font-weight: 100;
}

.vr-logo {
	width: 74px;
    height: 22px;
    position: absolute;
    bottom: 1;
    right: 1;
	opacity: 0.8;
}

@keyframes lds-eclipse {
    0% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    50% {
        -webkit-transform: rotate(180deg);
        transform: rotate(180deg);
    }
    100% {
        -webkit-transform: rotate(360deg);
        transform: rotate(360deg);
    }
}

@-webkit-keyframes lds-eclipse {
    0% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    50% {
        -webkit-transform: rotate(180deg);
        transform: rotate(180deg);
    }
    100% {
        -webkit-transform: rotate(360deg);
        transform: rotate(360deg);
    }
}

.lds-eclipse {
    position: relative;
}

.lds-eclipse div {
    position: absolute;
    -webkit-animation: lds-eclipse 1s linear infinite;
    animation: lds-eclipse 1s linear infinite;
    width: 160px;
    height: 160px;
    top: 20px;
    left: 20px;
    border-radius: 50%;
    box-shadow: 0 4px 0 0 #337ab7;
    -webkit-transform-origin: 80px 82px;
    transform-origin: 80px 82px;
}

.lds-eclipse {
    width: 200px !important;
    height: 200px !important;
    -webkit-transform: translate(-100px, -100px) scale(1) translate(100px, 100px);
    transform: translate(-100px, -100px) scale(1) translate(100px, 100px);
}

.lds-css {
	text-align: center;
    margin-left: 25%;
    padding-top: 35px;
}

.vr-success-message {
	z-index: 1;
    width: 100%;
    height: 100%;
    background-color: #5cb85c;
    position: absolute;
	text-align: center;
}

.vr-play-image {
	background-image: url('data:image/png;base64,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');
}

.vr-repeat-image {
	background-image: url('data:image/png;base64,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');
}

.vr-save-image {
	background-image: url('data:image/png;base64,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');
}

.vr-stop-image {
	background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAAiwAAAIsBRmWzPwAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAQASURBVGiB1Zo9bBtlGMf/z+vYXbDk10dMlqpJkVI6oYgiUIZIqSggFoQoKqrbDgipdEIsIJXdQ2EAKRUw8VGChFpQYEJFhJFKKAgYqgRRtUVdUnN+jRwW+3J/hlyobZ3d+/TFv83vx93v8d2934KEMMYcALBI8nERmSU5A6AM4AGvyBYAW0RukvxDRH4m+WO5XP4riftLnMrNZnOG5GkAVZKzES+zISLLAC5prW9FdYkUiDFmDsDbJF8AoKLevA9XRL4CUNNa/xq2cqhANjc3H8rn8+8AOBW2bghI8rNCofBmsVi8G7RSYJlGo3ESwEUApSh2ETAkz1mW9WWQwvcNhOS+ZrO5RPLV+G6R+FBr/bqItIcVGhpIvV4vTkxMfE3yqWTdQnPVcZwXK5XK1qACAwOp1+vFXC73PYAnUlELzzXHcY4NCsa3xSFZyOVyl7F3ggCAJ3O53Dck9/ll+gZijFkC8EyqWhEQkaPGmPd88/oTvNZpOXWrGJB8ub816wnE6yfWMbomNiomn88/0t3P9Lxa+Xz+Xez9IABAt9vtC90J/z8RY8wcyTWk12MnDUVkTmv9GwBMdGWcR8AgSKJWq6Uhh2q1iunp6SBFheR5ACcAT7zZbM64rvsnAg4At7e3MTk5GVF1OCsrK1hYWAha3BWRg1rr2woAvKF4UqPYUaJIngLuyVczlIlLFQCUMeZAjEnRXuCwbdv7FYCjWZvERSm1qEg+lrVIXEgeUSJyKGuRBJhVJA9mbZEADyuMx5DkfpQU7q07jTPFcewEfVHYWQEcd1oKwD9ZWyRAU4nIjawtEuCGIrmetUVcSG4oEfkla5G4KKXWFIDVrEXi4rruqtJa3wawkbVMDK5blnVHAYC3PzGuLAPexEpEPgfgZqoTje3dh6AAoFQq3fQ2WcaNK96n0bOKUgNwHAFWUkQE8/PzqZiVSoHHsMSO845Td06j0fgUwJnktNKD5MeWZb2y+7snkFarVel0OusA9MjNwtHwlkzruwk9o99isXiX5LnRe4WD5NnuIACftSxvlfujkVmFZ8myrCv9ib4fNsm8MeZbAM+mrhUCkj+Uy+Xn/PYTfSdWItJxHOclANdStwvOT51O5/lBm6IDZ4iVSmXLcZxjAK6mphac7xzHeXpqaurfQQWCbE8XjDHvA3gtUbXgXNRavyEinWGFAu+F2LZ9QkQ+wOia5gbJs34fth+hNnVarVal3W5fEJEzYeuGgCQ/KRQKb/U3scOIeqjmUW+T5TgSPFQD4DKAWrlc/j1s5Vj/qndG6zTJkwAOR7zMdQBfALgU5+xWYq+Hbdv7lVKLJI8AOCQi0yQfRNfBMxH5m+QtkutKqTXXdVcty7qTxP3/A1nVbBpJQvbSAAAAAElFTkSuQmCC');
}

.vr-success-icon {
	background-image: url('data:image/png;base64,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');
	display: inline-block;
	width: 150px;
	height: 150px;
	margin-top: 50px;
}

.vr-success-text {
	color: #eee;
    font-size: 1.3em;
}
</style>
